import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import type { DialogController } from "../../../utils/hooks/use-dialog";
import type { FC } from "react";

/** Stands in for dashboard features that aren't built yet. */
export const UnderConstructionDialog: FC<{ dialog: DialogController<unknown> }> = ({ dialog }) => (
  <Dialog open={dialog.open} onClose={dialog.handleClose}>
    <DialogTitle>Under construction</DialogTitle>
    <DialogContent>
      <DialogContentText>Check back soon</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={dialog.handleClose} data-analytics-id="dashboard-under-construction-cancel">
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);
